var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    "aria-labelledby": titleId,
    role: "img",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "layer1",
    d: "M40.568 5.913l2.79-5.008a.543.543 0 0 0-.2-.8.44.44 0 0 0-.7.2l-2.886 5.107A18.933 18.933 0 0 0 32 3.91a18.933 18.933 0 0 0-7.572 1.5L21.539.3a.52.52 0 0 0-.8-.2.543.543 0 0 0-.2.8l2.79 5.008a15.824 15.824 0 0 0-9.166 14.021v.3h35.472v-.3c.099-6.104-3.587-11.312-9.067-14.016zM23.83 13.825a1.6 1.6 0 1 1 1.594-1.6 1.52 1.52 0 0 1-1.594 1.6zm16.339 0a1.6 1.6 0 1 1 1.594-1.6 1.578 1.578 0 0 1-1.593 1.6zM14.266 37.56v9.815a4.051 4.051 0 0 0 4.085 4.106h3.089v8.613A3.9 3.9 0 0 0 25.325 64a3.967 3.967 0 0 0 3.886-3.906v-8.613h5.48v8.613a3.886 3.886 0 1 0 7.771 0v-8.613h3.088a4.051 4.051 0 0 0 4.085-4.106V21.536H14.266zm40.848-16.825a3.9 3.9 0 0 0-3.886 3.906v16.625a3.886 3.886 0 1 0 7.771 0V24.741a3.988 3.988 0 0 0-3.885-4.006zm-46.228 0A3.9 3.9 0 0 0 5 24.641v16.625a3.886 3.886 0 1 0 7.771 0V24.741a3.924 3.924 0 0 0-3.885-4.006z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.6431468b129f50eb76f69f29524b5e6c.svg";
export { ForwardRef as ReactComponent };